import { render, staticRenderFns } from "./StopOutlined.vue?vue&type=template&id=15637d3f"
import script from "./StopOutlined.vue?vue&type=script&lang=js"
export * from "./StopOutlined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports